/* eslint-disable */
export default {
  searchPlaceholder: '検索...',
  refresh: '更新',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
